module.exports = __webpack_public_path__ + "static/media/Fax-machine-sound.928a5764.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audios/Fax-machine-sound.mp3
// module id = 2604
// module chunks = 0